import { CategoryState, RootState } from '@/types/store'
import { Module } from 'vuex'

import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

const state: CategoryState = {
  isCategoryLoading: false,
  children: [],
  parents: [],
}

export const category: Module<CategoryState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
